import en from './en.json'
import bg from './bg.json'

export default {
  en,
  bg,
}



// WEBPACK FOOTER //
// ./src/-service-app/i18n/index.js